"use strict";
var ClientInfoService = (function () {
    function ClientInfoService() {
        this.service = {};
        this.code_access = 0;
        this.userOrder = {
            ip: '',
            phone: '',
            code: '',
            service_id: 0
        };
        this.socket = null;
        this.grantAccess = false;
    }
    return ClientInfoService;
}());
exports.ClientInfoService = ClientInfoService;



/*****************
 ** WEBPACK FOOTER
 ** ./app/clientinfo.service.ts
 ** module id = 936
 ** module chunks = 1
 **/